import { c as _c } from "react/compiler-runtime";
import { ContactSlugEnum } from '@systemeio/types';
import UpdateFieldsModal from 'modules/contacts/components/update-fields-modal';
import { useManageCustomerFields } from 'modules/contacts/components/update-fields-modal/hooks/use-manage-customer-fields';
import { ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface';
import { useUpdateSubscriptionFields } from 'modules/profile/manage-subscriptions/hooks/use-update-subscription-fields';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface UpdateCustomerFieldsModalProps {
  opened: boolean;
  onClose: () => void;
  subscriptionId: number;
}
function UpdateSubscriptionFieldsModal(t0) {
  const $ = _c(16);
  const {
    opened,
    onClose,
    subscriptionId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== opened || $[1] !== subscriptionId) {
    t1 = {
      subscriptionId,
      isFetchAllowed: opened
    };
    $[0] = opened;
    $[1] = subscriptionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    mutate,
    isLoadingFields
  } = useManageCustomerFields(t1);
  let t2;
  if ($[3] !== subscriptionId) {
    t2 = {
      subscriptionId
    };
    $[3] = subscriptionId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    updateSubscriptionFields,
    isFetchUpdate
  } = useUpdateSubscriptionFields(t2);
  const removeUnusedFields = _temp2;
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.settings.manage_subscriptions.update_information");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== data || $[8] !== isFetchUpdate || $[9] !== isLoadingFields || $[10] !== mutate || $[11] !== onClose || $[12] !== opened || $[13] !== t3 || $[14] !== updateSubscriptionFields) {
    t4 = <UpdateFieldsModal opened={opened} onClose={onClose} data={data} mutate={mutate} isLoadingFields={isLoadingFields} isFetching={isFetchUpdate} updateFields={updateSubscriptionFields} title={t3} unusedFields={removeUnusedFields} />;
    $[7] = data;
    $[8] = isFetchUpdate;
    $[9] = isLoadingFields;
    $[10] = mutate;
    $[11] = onClose;
    $[12] = opened;
    $[13] = t3;
    $[14] = updateSubscriptionFields;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp2(data_0) {
  if (!data_0) {
    return;
  }
  return {
    ...data_0,
    fieldValues: data_0.fieldValues.filter(_temp)
  };
}
function _temp(item) {
  return ![ContactSlugEnum.Email, ContactSlugEnum.Country, ContactSlugEnum.TaxNumber].includes(item.contactField.slug as ContactSlugEnum);
}
export default UpdateSubscriptionFieldsModal;